import React from "react";
import "../pages/Event.css"; // import css

export default function EventsPage() {
  return (
    <div className="events-cover"></div>
  );
}
